// ======================================================================
// File Name       : ParticipantDetailInfo
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================


import React from 'react';
import { Form, Col } from 'react-bootstrap';

class ParticipantDetailInfo extends React.Component {
  render() {
    const {
      userName,
      groupNames,
    } = this.props;
    return (
      <div>
        <h3>ユーザー別参加実績詳細</h3>
        <Form className="margin-top-10">
          <Col sm={12}>
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">ユーザー名</Col>
              <Col sm={7} className="padding-top-bottom-10">{userName}</Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} className="form-label">ユーザーグループ名</Col>
              <Col sm={7} className="padding-top-bottom-10">{groupNames}</Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default ParticipantDetailInfo;
